<template>
	<div class="ColoredTrendArrow" v-bind:style="computedStyles">➜</div>
</template>

<script>
import { percentOfValueInRange } from "../../utils";
export default {
	name: "percent-from-center-bar",
	props: {
		property: Object,
		targetActor: Object,
		value: Number,
		backgroundColors: {
			type: Array,
			default: function () {
				const baseColors = [
					"#BB0000",
					"#BB2900",
					"#BB5300",
					"#BB7C00",
					"#BBA600",
					"#A6BB00",
					"#7CBB00",
					"#53BB00",
					"#29BB00",
					"#00BB00",
				];
				return this.property?.is_desirable === false
					? [...baseColors].reverse()
					: baseColors;
			},
		},
	},
	data: function () {
		return {
			min: this.property.min_modifying_value,
			max: this.property.max_modifying_value,
			normalizedModifyingValue:
				(Math.abs(this.property.min_modifying_value) +
					Math.abs(this.property.max_modifying_value)) /
				2,
		};
	},
	computed: {
		apBaseValue() {
			const actorProperty = this.targetActor
				? VueStore.getters.actorPropertyOfTypeFor(
						this.targetActor,
						this.property.type_key,
					)
				: undefined;
			const apBaseValue = actorProperty ? actorProperty.base_value : undefined;
			return apBaseValue || (this.min + this.max) / 2;
		},
		computedStyles() {
			const colorSliceIndex = Math.ceil(this.backgroundColors.length / 2);
			let minForRange;
			let maxForRange;
			let degreesMultiplier;
			let workingColorArray = this.backgroundColors;
			if (this.value < 0) {
				maxForRange = this.min;
				minForRange = 0;
				degreesMultiplier = this.apBaseValue < 0 ? -90 : 90;
			} else {
				minForRange = 0;
				maxForRange = this.max;
				degreesMultiplier = this.apBaseValue >= 0 ? -90 : 90;
			}
			if (degreesMultiplier < 0) {
				// Take the right half of the array, i. e. the green part
				workingColorArray = workingColorArray.slice(colorSliceIndex);
			} else {
				// Take the left half of the array and then reverse, so that "#BB0000" is the *last* entry
				workingColorArray = [
					...workingColorArray.slice(0, colorSliceIndex),
				].reverse();
			}
			let percentOfRange = percentOfValueInRange(
				this.value,
				minForRange,
				maxForRange,
			);
			if (percentOfRange > 100) {
				percentOfRange = 100;
			}

			const colorIndex = Math.round(
				(percentOfRange * (workingColorArray.length - 1)) / 100,
			);
			return {
				transform: `rotate(${(percentOfRange / 100) * degreesMultiplier}deg)`,
				color: workingColorArray[colorIndex],
			};
		},
	},
	mounted() {},
	beforeDestroy() {
		pp.vue.bus.$off("percent-bar-value-CHANGED");
	},
};
</script>
